import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import EditTagsModal from './EditTagsModal.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { ButtonIcon } from '@fabric-app/ui/components/Button';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import { IconNavigational24Tag } from '@fabric-app/icons/svg';

const TagButtonBase = styled(ButtonIcon).withConfig({
  displayName: "TagButton__TagButtonBase",
  componentId: "sc-31ca241d-0"
})([
  `position:absolute;bottom:20px;left:1rem;z-index:10;background:`,
  `;color:`,
  `;`,
  `{&:hover{background:`,
  `;}}`
], cssVar["color-bg-secondary-button"], cssVar["color-text-primary"], mediaHover, cssVar["color-bg-tertiary"]);
const StyledIconTagFilled = styled(IconNavigational24Tag).withConfig({
  displayName: "TagButton__StyledIconTagFilled",
  componentId: "sc-31ca241d-1"
})([
  `&[data-selected='true']{color:`,
  `;}`
], cssVar["color-app-primary-text"]);
const TagButton = ({ selectedTags, ...props }) => {
  const { data: user } = useQueryUserInfo();
  const isLoggedIn = !!user;
  const accessToken = useContextAccessToken();
  if (!isLoggedIn || !!accessToken) return null;
  return /* @__PURE__ */ jsx(TagButtonBase, {
    variant: "bg-secondary",
    ...props,
    children: /* @__PURE__ */ jsx(StyledIconTagFilled, {
      "data-selected": Boolean((selectedTags?.length ?? 0) > 0)
    })
  });
};
const TagButtonWithModal = ({ onTagSelect, selectedTags, onOpenChange, open, ...props }) => {
  const { data: user } = useQueryUserInfo();
  const isLoggedIn = !!user;
  const accessToken = useContextAccessToken();
  if (!isLoggedIn || !!accessToken) return null;
  return /* @__PURE__ */ jsx(EditTagsModal, {
    selectedTags,
    onSelect: onTagSelect,
    open,
    onOpenChange,
    selectedResourcesCount: 1,
    children: /* @__PURE__ */ jsx(TagButton, {
      ...props,
      selectedTags
    })
  });
};

export { TagButtonWithModal, TagButton as default };
//# sourceMappingURL=TagButton.js.map
